<script setup lang="ts">

import { ModalName } from '@/constants/modals';

import { useModalStore } from "@/dsComponents/modals/modalStore";

import DocumentPreview from "@/components/DocumentPreview.vue";
import MissionDetailsModal from "@/components/Mission/MissionSideModal/MissionDetailsModal.vue";
import WorkerSelectionModal from "@/components/Mission/MissionSideModal/WorkerSelectionModal.vue";
import InterviewEditModal from "@/components/modal/interviewReport/InterviewEditModal.vue";
import InterviewReportModal from "@/components/modal/interviewReport/InterviewReportModal.vue";
import NirAlreadyExistsModal from "@/components/modal/NirAlreadyExistsModal.vue";
import ProfileLastContactModal from "@/components/modal/Profile/lastContact/ProfileLastContactModal.vue";
import ProfileNoteModal from "@/components/modal/Profile/note/ProfileNoteModal.vue";
import ProfilPreviewModal from "@/components/modal/Profile/previewProfile/ProfilPreviewModal.vue";
import RejectProfileWorkerModal from "@/components/modal/Profile/rejectProfile/ProfileRejectModal.vue";
import ProfileScheduleInterviewModal from "@/components/modal/Profile/scheduleInterview/ProfileScheduleInterviewModal.vue";
import ProfileUnavailabilityModal from "@/components/modal/Profile/unavailability/ProfileUnavailabilityModal.vue";
import SendOrderToEvoliaModal from "@/components/modal/SendOrderToEvoliaModal.vue";
import TooMuchWorkerConfirm from "@/components/modal/TooMuchWorkerConfirm.vue";
import PaymentRequestActionModal from "@/components/paymentRequest/PaymentRequestActionModal.vue";
import PaymentRequestCreationModal from "@/components/paymentRequest/PaymentRequestCreationModal.vue";
import SendActiveProposalModal from "@/modules/activeProposal/components/SendActiveProposalModal.vue";
import ShowActiveProposalEmail from "@/modules/activeProposal/components/ShowActiveProposalEmail.vue";
import ClientSalesforceImport from "@/modules/clients/components/ClientSalesforceImport.vue";
import JustificationModal from "@/modules/companyNeed/components/modals/createOrder/JustificationModal.vue";
import ManageOrderModal from "@/modules/companyNeed/components/modals/createOrder/ManageOrderModal.vue";
import ManageCompanyNeedModal from "@/modules/companyNeed/components/modals/ManageCompanyNeedModal.vue";
import MoveWorkerCompanyNeedModal from "@/modules/companyNeed/components/modals/MoveWorkerCompanyNeedModal.vue";
import AddWorkerToMissionModal from "@/modules/companyNeed/components/modals/mission/addWorkerToMission/AddWorkerToMissionModal.vue";
import CancelMissionModal from "@/modules/companyNeed/components/modals/mission/CancelMissionModal.vue";
import CompanyNeedMissionDetailsModal from "@/modules/companyNeed/components/modals/mission/MissionDetailsModal.vue";
import MissionExtensionModal from "@/modules/companyNeed/components/modals/mission/MissionExtensionModal.vue";
import ValidateMissionModal from "@/modules/companyNeed/components/modals/mission/ValidateMissionModal.vue";
import RepublishUnavailableModal from "@/modules/companyNeed/components/modals/RepublishUnavailableModal.vue";
import SearchCompanyNeedsModal from "@/modules/companyNeed/components/modals/SearchCompanyNeedsModal.vue";
import WorkerAgencyRejectModal from "@/modules/companyNeed/components/modals/WorkerAgencyRejectModal.vue";
import CancelMission from "@/modules/missions/components/modals/CancelMission.vue";
import WorkersBulkActionsModal from "@/modules/worker/components/bulkActions/WorkersBulkActionsModal.vue";
import CreateCandidateModal from "@/modules/worker/components/create/CreateCandidateModal.vue";
import DuplicatedWorkerModal from "@/modules/worker/components/create/DuplicatedWorkerModal.vue";
import SwitchWorkerStatus from "@/modules/worker/components/SwitchWorkerStatus.vue";
import WorkerAskedChangesModal from "@/modules/worker/components/workerAskChanges/WorkerAskedChangesModal.vue";

const modalStore = useModalStore();

const componentByModalName = {
    [ModalName.MissionDetails]: { component: MissionDetailsModal, props: {} },
    [ModalName.MissionSelection]: { component: WorkerSelectionModal, props: {} },
    [ModalName.SendOrderToEvolia]: { component: SendOrderToEvoliaModal, props: {} },
    [ModalName.CancelMissionLegacy]: { component: CancelMission, props: {} },
    [ModalName.PaymentRequestCreationModal]: { component: PaymentRequestCreationModal, props: {} },
    [ModalName.PaymentRequestActionModal]: { component: PaymentRequestActionModal, props: {} },
    [ModalName.TooMuchWorkerConfirm]: { component: TooMuchWorkerConfirm, props: {} },
    [ModalName.ProfileUnavailabilityModal]: { component: ProfileUnavailabilityModal, props: {} },
    [ModalName.SwitchWorkerStatus]: { component: SwitchWorkerStatus, props: {} },
    [ModalName.ShowActiveProposalEmail]: { component: ShowActiveProposalEmail, props: {} },
    [ModalName.DocumentPreviewModal]: { component: DocumentPreview, props: {} },
    [ModalName.NirAlreadyExistsModal]: { component: NirAlreadyExistsModal, props: {} },
    [ModalName.SearchCompanyNeedsModal]: { component: SearchCompanyNeedsModal, props: {} },
    [ModalName.ManageCompanyNeedModal]: { component: ManageCompanyNeedModal, props: {} },
    [ModalName.MoveWorkerCompanyNeedModal]: { component: MoveWorkerCompanyNeedModal, props: {} },
    [ModalName.ManageOrderModal]: { component: ManageOrderModal, props: {} },
    [ModalName.JustificationModal]: { component: JustificationModal, props: {} },
    [ModalName.CompanyNeedMissionDetailsModal]: { component: CompanyNeedMissionDetailsModal, props: {} },
    [ModalName.CompanyNeedMissionAddWorkerToMissionModal]: { component: AddWorkerToMissionModal, props: {} },
    [ModalName.RejectProfileWorkerModal]: { component: RejectProfileWorkerModal, props: {} },
    [ModalName.LastContactModal]: { component: ProfileLastContactModal, props: {} },
    [ModalName.ProfileScheduleInterviewModal]: { component: ProfileScheduleInterviewModal, props: {} },
    [ModalName.ProfilPreviewModal]: { component: ProfilPreviewModal, props: {} },
    [ModalName.WorkerAgencyRejectModal]: { component: WorkerAgencyRejectModal, props: {} },
    [ModalName.CancelMission]: { component: CancelMissionModal, props: {} },
    [ModalName.ValidateMission]: { component: ValidateMissionModal, props: {} },
    [ModalName.MissionExtensionModal]: { component: MissionExtensionModal, props: {} },
    [ModalName.SendActiveProposalModal]: { component: SendActiveProposalModal, props: {} },
    [ModalName.InterviewReportModal]: { component: InterviewReportModal, props: {} },
    [ModalName.InterviewEditModal]: { component: InterviewEditModal, props: {} },
    [ModalName.WorkerAskedChangesModal]: { component: WorkerAskedChangesModal, props: {} },
    [ModalName.ProfileNoteModal]: { component: ProfileNoteModal, props: {} },
    [ModalName.CreateCandidateModal]: { component: CreateCandidateModal, props: {} },
    [ModalName.DuplicatedWorkerModal]: { component: DuplicatedWorkerModal, props: {} },
    [ModalName.RepublishUnavailableModal]: { component: RepublishUnavailableModal, props: {} },
    [ModalName.WorkersBulkActionsModal]: { component: WorkersBulkActionsModal, props: {} },
    [ModalName.ClientSalesforceImportModal]: { component: ClientSalesforceImport, props: {} },
};
</script>
<template>
    <router-view />
    <div id="ds-dropdowns"></div>
    <div id="teleport-ask-ai"></div>
    <div id="teleport-modal"></div>
    <div id="teleport-side-modal"></div>

    <template v-for="modalName of modalStore.state.open" :key="modalName">
        <component
            v-if="modalStore.state.open.includes(modalName) && componentByModalName[modalName]"
            :is="componentByModalName[modalName].component"
            v-bind="{
                ...componentByModalName[modalName].props,
                ...modalStore.state.props[modalName],
                ...modalStore.state.injectedProps[modalName],
            }"
            @close="modalStore.actions.close(modalName)"
            open
        />
    </template>
</template>
<style lang="scss">
#app {
    width: 100%;
    height: 100%;
}

#teleport-ask-ai {
    position: relative;
    z-index: 10000;
}

#teleport-modal,
#teleport-side-modal {
    position: relative;
    z-index: 11000;
}
</style>
